import { Component, EventEmitter, Input, OnInit, Output, Injector } from '@angular/core';
import { BaseComponent } from '../../../shared/components';
import { AbstractControl } from '@angular/forms';
import { nextTick } from 'process';
/**
 * 密碼輸入元件
 */
@Component({
  selector: 'sigv-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.css'],
})
export class InputPasswordComponent extends BaseComponent implements OnInit {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** formControl物件
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** 空值欲設提示 */
  @Input() placeholder?: string;
  /** 欄位寬度 */
  @Input() maxlength?: number;
  /** 密碼遮罩 */
  @Input() toggleMask?: boolean;
  /** 密碼強度顯示 */
  @Input() feedback?: boolean;
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /**blur事件 */
  @Output() blur: EventEmitter<any> = new EventEmitter();
  useWidth = '';
  constructor(injector: Injector) {
    super(injector);
    this.useWidth = `${this.maxlength}px`;
  }
  render = true;
  forceRender() {
    this.render = false;
    nextTick(() => {
      this.render = true;
    });
  }
  blurEvent(event: any) {
    this.blur.emit(event);
  }
  ngOnInit() {
    this.logger.debug(
      'input-password init',
      ' bindingFormControl:',
      this.bindingFormControl
    );
    this.useWidth = `${String(this.maxlength)}px`;
  }
}
